import {
  Box,
  Button,
  Grid2,
  Link,
  Menu,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useContext, useMemo } from "react";
import RenderLogo from "./RenderLogo";
import { ReactComponent as SearchIcon } from "Assets/Icons/Home/SearchIcon.svg";
import { ReactComponent as CourseActionIcon } from "Assets/Icons/Home/CourseActionIcon.svg";
import { ReactComponent as EarnIcon } from "Assets/Icons/Home/EarnIcon.svg";
import { ReactComponent as StreakIcon } from "Assets/Icons/Home/StreakIcon.svg";
import { ReactComponent as CurrencyIcon } from "Assets/Icons/Home/CurrencyIcon.svg";
import { ReactComponent as ShopIcon } from "Assets/Icons/Home/ShopIcon.svg";
import { ReactComponent as AwardIcon } from "Assets/Icons/Home/AwardIcon.svg";
import { ReactComponent as NotificationIcon } from "Assets/Icons/Home/NotificationIcon.svg";
import { ReactComponent as ProfileIcon } from "Assets/Icons/Home/ProfileIcon.svg";
import { ReactComponent as HamburgerIcon } from "Assets/Icons/Home/HamburgerIcon.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TimelineDot } from "@mui/lab";
import SideDrawer from "./SideDrawer";
import AwardDrawer from "./AwardDrawer";
import { StyledMenu } from "./StyledMenu";
import NotificationList from "Components/Notification/NotificationList";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, getCourses, getModules, getNotifications, getCourseScore, getStreakTiming, getTodayStreakScore, getStreakScore } from "Slices/thunks";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import Cookies from "js-cookie";

import { DirectionContext } from "App";
import GoalDialog from "Components/Home/GoalDialog";
import StreakDialog from "Components/Home/StreakDialog";
import StreakModeDialog from "Components/Home/StreakModeDialog";
import useTimer from "Hooks/useTimer";


const styles = (theme) => ({
  display: "flex",
  alignItems: "center",
  padding: "15px 24px",
  backgroundColor: theme.palette.background.default,
  justifyContent: "space-between",
  "&>div": {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  "& .headerLeft": {},
  "& .headerRight": {
    "& .streaks": {
      display: "flex",
      alignItems: "center",
      cursor: "pointer"
    },
  },
});

const Header = () => {
  const navigate = useNavigate();
  const dispatch =  useDispatch();
  const language = localStorage.getItem('LANGUAGE') || "en";
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [goalOpen, setGoalOpen] = useState(false);
  const [streakOpen, setStreakOpen] = useState(false);
  const [streakModeOpen, setStreakModeOpen] = useState(false);
  const [awardDrawer, setAwardDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const [courseAnchorEl, setCourseAnchorEl] = useState(null);
  const [currentLanguage, setCurrentLanguage] = useState(language);
  // const { remainingHour } = useTimer();

  const { changeDirection } = useContext(DirectionContext);


  const { Profile, Courses, TodayScore, Translation } = useSelector((state) => ({
    Profile: state.Profile.profile,
    Courses: state.Course.courses,
    TodayScore: state.Dashboard.todayScore || {},
    Translation: state.Translation.translation?.Header || {},
  }));

  const RemainingHours = useMemo(() => {
    if (!TodayScore?.EndTime || TodayScore?.EndDay == null) return 0;

    const now = new Date();
    const startDate = new Date();
    const endDate = new Date();

    startDate.setDate(startDate.getDate() - TodayScore.StartDay);
    endDate.setDate(endDate.getDate() + TodayScore?.EndDay); 

    const startTime = new Date(`${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')} ${TodayScore?.StartTime}`);
    const endTime = new Date(`${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')} ${TodayScore?.EndTime}`);
    
    if (now > endTime) {
      endTime.setDate(endTime.getDate() + 1);
    } 

    const diffMs = startTime > now ? startTime.getTime() - now.getTime() : endTime.getTime() - now.getTime();

    const remainingHours = Math.floor(diffMs / (1000 * 60 * 60));

    return Math.floor(remainingHours)
  }, [TodayScore])

  const handleChangeLanguage = () => {
    const newLang = currentLanguage === "en" ? "ar" : "en";
    changeDirection(newLang)
    // localStorage.setItem("LANGUAGE", newLang);
    // localStorage.setItem("langId", newLang === "en" ? 1 : 2);
    // setCurrentLanguage(newLang);
    // dispatch(getTranslations());
    // setProfileAnchorEl(null);
    // window.location.reload();
  }

  const handleChangeCourse = (course) => {
    const courseId = localStorage.getItem("CourseID") 
    if (courseId != course?.ID) {
      localStorage.setItem('CourseID', course?.ID)
      dispatch(getModules({CourseID: course?.ID}))
    }
    navigate(`/core-curriculum/0/classes`)
    setCourseAnchorEl(null);
  }

  const handleStreakClick = () => {
    const courseId = localStorage.getItem("CourseID");
    // const date = new Date();
    if (courseId) {
      // dispatch(getTodayStreakScore({CourseID: courseId}))
      dispatch(getStreakScore({CourseID: courseId}))
    }
    setStreakOpen(true);
  }

  const handleLogout = () => {
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
    // localStorage.removeItem("CourseID")
    setProfileAnchorEl(null);
    signOut(auth);
    navigate("/login");
  }

  useEffect(() => {
    const courseId = localStorage.getItem("CourseID");
    const date = new Date();
    if (courseId) {
      dispatch(getCourseScore({CourseID: courseId}))
      // dispatch(getTodayStreakScore({CourseID: courseId}))
      dispatch(getStreakScore({CourseID: courseId, Year: date.getFullYear(), Month: date.getMonth()}))
    }
    dispatch(getProfile())
    dispatch(getCourses());
    dispatch(getNotifications());
    dispatch(getStreakTiming());

  }, [dispatch])

  return (
    <>
      <Grid2
        sx={(theme) => ({
          backgroundColor: theme.palette.background.blue,
          padding: "12px",
          textAlign: "center",
        })}
      >
        <Typography color="white" variant="body2">
          {Translation?.HeaderMessage}
        </Typography>
      </Grid2>
      <Grid2 sx={(theme) => styles(theme)}>
        <Grid2 className="headerLeft">
          <RenderLogo size="small" />
          <Button variant="contained" color="white" iconbutton>
            {" "}
            <SearchIcon />{" "}
          </Button>
          <Button variant="contained" color="white" iconbutton onClick={(e) => setCourseAnchorEl(e.currentTarget)}>
            {" "}
            <CourseActionIcon />
            <TimelineDot sx={{ margin: "auto 7px" }} color="success" />
            {Translation?.CourseActions}
          </Button>
          <Button variant="outlined" color="secondary" iconbutton onClick={() => navigate('/invite-friends')}>
            <EarnIcon /> &nbsp; {Translation?.ReferAndEarn}
          </Button>
        </Grid2>
        <Grid2 className="headerRight">
          <div className="streaks" onClick={handleStreakClick}>
            <StreakIcon />
            &nbsp; 0 &nbsp;
            <Typography fontWeight={500} color="error">
              {RemainingHours} {Translation?.HoursLeft}
              {/* {remainingHour} {Translation?.HoursLeft} */}
            </Typography>
          </div>
          <Button variant="contained" color="white" iconbutton>
            {" "}
            <CurrencyIcon />{" "}
          </Button>
          <Button variant="contained" color="white" iconbutton>
            {" "}
            <ShopIcon />{" "}
          </Button>
          <Button variant="contained" color="white" iconbutton onClick={(e) => setAwardDrawer(true)}>
            {" "}
            <AwardIcon />{" "}
          </Button>
          <Button
            onClick={(e) => setAnchorEl(e.currentTarget)}
            variant="contained"
            color="white"
            iconbutton
          >
            {" "}
            <NotificationIcon />{" "}
          </Button>
          <Button
            onClick={(e) => setProfileAnchorEl(e.currentTarget)}
            variant="contained"
            color="white"
            iconbutton
          >
            <ProfileIcon /> &nbsp; {Profile?.FirstName} <KeyboardArrowDownIcon />
          </Button>
          <Button iconbutton onClick={(e) => setDrawerOpen(true)}>
            <HamburgerIcon />
          </Button>
        </Grid2>
      </Grid2>
      <SideDrawer open={drawerOpen} handleClose={() => setDrawerOpen(false)} />
      <AwardDrawer open={awardDrawer} handleClose={() => setAwardDrawer(false)} />
      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <Box maxWidth={"400px"} padding={"10px 16px 10px 10px"}>
          <Typography
            display={"flex"}
            mb="10px"
            fontWeight={500}
            variant="title"
          >
            {Translation?.Notifications}
          </Typography>
          <NotificationList maxHeight="400px" />
          <Link
            justifyContent={"center"}
            display={"flex"}
            mt={"10px"}
            fontWeight={500}
            underline="none"
            href="#"
            onClick={() => {
              navigate("/notifications");
              setAnchorEl(null);
            }}
          >
            {Translation?.SeeAllNotifications}
          </Link>
        </Box>
      </StyledMenu>
      <StyledMenu
        anchorEl={profileAnchorEl}
        open={Boolean(profileAnchorEl)}
        onClose={() => setProfileAnchorEl(null)}
      >
        <MenuItem
          onClick={handleChangeLanguage}
          
        >
          {Translation?.ChangeLanguage}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setProfileAnchorEl(null);
            navigate("/settings");
          }}
        >
          {Translation?.Settings}
        </MenuItem>
        <MenuItem
          onClick={handleLogout}
        >
          {Translation?.Logout}
        </MenuItem>
      </StyledMenu>

      { Array.isArray(Courses) && Courses.length > 0 &&
        <StyledMenu
          anchorEl={courseAnchorEl}
          open={Boolean(courseAnchorEl)}
          onClose={() => setCourseAnchorEl(null)}
        >
        {  Courses.map((course, index) => {
          return (
            <MenuItem key={course.ID} onClick={() => handleChangeCourse(course)}>
              {course?.CourseName}
            </MenuItem>
          )
        }) }
        </StyledMenu>
      }

      <GoalDialog open={goalOpen} setOpen={setGoalOpen} />
      <StreakDialog open={streakOpen} setOpen={setStreakOpen} setGoalOpen={setGoalOpen} setStreakModeOpen={setStreakModeOpen} />
      <StreakModeDialog open={streakModeOpen} setOpen={setStreakModeOpen} />
    </>
  );
};

export default Header;
